<template>
    <div class="container-fluid">

        <!-- start page title -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right">
                        <ol class="breadcrumb m-0">
                            <li class="breadcrumb-item">
                                <router-link :to="{name: 'dashboard'}">Home</router-link>
                            </li>
                            <li v-if="component==='batches'" class="breadcrumb-item active">Batches</li>
                            <li v-if="component==='production-steps' || component==='production-report'" class="breadcrumb-item">
                                <router-link :to="{name: 'batches'}">Batches
                                </router-link>
                            </li>
                            <li v-if="component==='production-steps'" class="breadcrumb-item active">{{process_name}}</li>
                            <li v-if="component==='batch-report'" class="breadcrumb-item active">Report</li>
                        </ol>
                    </div>
                    <h4 class="page-title" v-if="component==='batch-report'">Batch Report</h4>
                    <h4 class="page-title" v-else>Batches</h4>
                    <h4 class="page-title" v-if="component==='production-steps'"><span class="text-muted">{{process_name}}</span></h4>
                </div>
            </div>
        </div>
        <!-- end page title -->
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "ProductionLayout",
        data() {
            return {
                component: null,
                process_name: null,
            }
        },
        watch: {
            $route(to, from) {
                this.component = to.name;
                this.process_name = this.$route.params.batchid
            }
        },
        created() {
            this.component = this.$route.name;
            this.process_name = this.$route.params.batchid
        }
    }
</script>

<style scoped>

</style>